import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { toast } from "react-toastify";
import LoadingSpinner from "../components/LoadingSpinner";
import "./ReviewPage.css";

const STAR_HINTS = {
  1: "😞 Poor experience",
  2: "😐 Below average",
  3: "🙂 It was okay",
  4: "😄 Great ride!",
  5: "🤩 Absolutely loved it!",
};

function ReviewPage() {
  const { bookingId } = useParams();
  const navigate = useNavigate();

  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const displayRating = hoverRating || rating;

  const submitReview = () => {
    if (rating === 0) {
      toast.warn("Please select a star rating first!");
      return;
    }

    if (!comment.trim()) {
      toast.warn("Please write a short comment about your ride!");
      return;
    }

    setLoading(true);
    axiosClient
      .post("/reviews", { bookingId, rating, comment })
      .then(() => {
        toast.success("🎉 Review submitted! Thank you.");
        navigate("/my-bookings");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to submit review");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="review-page">
      {/* Submitting overlay */}
      {loading && <LoadingSpinner overlay message="Submitting review" sub="Thank you for your feedback…" />}

      <div className="review-card">

        {/* Header */}
        <div className="review-header">
          <span className="review-icon">🛵</span>
          <h1 className="review-title">Rate Your Ride</h1>
          <p className="review-subtitle">Your feedback helps us improve for everyone</p>
        </div>

        <div className="review-divider" />

        {/* Star Rating */}
        <div className="star-section">
          <span className="star-label">Your Rating</span>
          <div className="star-row">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                className={`star-btn ${displayRating >= star ? "active" : ""}`}
                onClick={() => setRating(star)}
                onMouseEnter={() => setHoverRating(star)}
                onMouseLeave={() => setHoverRating(0)}
                aria-label={`Rate ${star} stars`}
              >
                ⭐
              </button>
            ))}
          </div>
          <p className="star-hint">
            {displayRating > 0 ? STAR_HINTS[displayRating] : "Tap a star to rate"}
          </p>
        </div>

        {/* Comment */}
        <div className="comment-section">
          <span className="comment-label">Your Experience</span>
          <textarea
            className="comment-textarea"
            placeholder="Tell us about your ride — what did you love? Any suggestions?"
            value={comment}
            onChange={(e) => setComment(e.target.value.slice(0, 500))}
          />
          <p className="char-count">{comment.length} / 500</p>
        </div>

        <button
          className="review-submit-btn"
          onClick={submitReview}
          disabled={loading || rating === 0}
        >
          Submit Review ✨
        </button>

        {/* Back */}
        <button className="review-back" onClick={() => navigate(-1)}>
          ← Back to My Bookings
        </button>

      </div>
    </div>
  );
}

export default ReviewPage;
